/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_SetsInputs */

const en_platform_plan_sets = /** @type {(inputs: Platform_Plan_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets`)
};

const pl_platform_plan_sets = /** @type {(inputs: Platform_Plan_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie`)
};

/**
* | output |
* | --- |
* | "Sets" |
*
* @param {Platform_Plan_SetsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_sets = /** @type {((inputs?: Platform_Plan_SetsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_SetsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_sets(inputs)
	return en_platform_plan_sets(inputs)
});